export const type = {
    LOGIN : 'LOGIN',
    LOGOUT: 'LOGOUT',
    CAMPAIGN_SEARCH: 'CAMPAIGN_SEARCH',
    CAMPAIGN_RESULT: 'CAMPAIGN_RESULT',
    SWITCH_HOME_SECTION : 'SWITCH_HOME_SECTION',
    SELECT_LOG_TYPE: 'SELECT_LOG_TYPE',
    API_LOGS: 'API_LOGS',
    EXTENSION_LOGS: 'EXTENSION_LOGS',
    SMTP_PUSH_LOGS: 'SMTP_PUSH_LOGS',
    OUTBOUND_LOGS: 'OUTBOUND_LOGS',
    DRAFTEDIT_LOGS: 'DRAFTEDIT_LOGS',
    PROCESSING_LOGS: 'PROCESSING_LOGS',
    SHEET_LOGS: 'SHEET_LOGS',
    WARMUP_LOGS: 'WARMUP_LOGS',
    CAMPAIGN_ERROR_LOGS: 'CAMPAIGN_ERROR_LOGS',
    STATUS_LOGS: 'STATUS_LOGS',
    CLEAR_LOGS: 'CLEAR_LOGS',
    CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
    SMTP_LOGS: 'SMTP_LOGS',
    COLD_SMTP_SEARCH_TERM: 'COLD_SMTP_SEARCH_TERM',
    COLD_SMTP_DOMAINSEARCH_RESULT : 'COLD_SMTP_DOMAINSEARCH_RESULT',
    COLD_SMTP_USER_RESULT : 'COLD_SMTP_USER_RESULT',
    COLD_SMTP_DOMAIN_RESULT : 'COLD_SMTP_DOMAIN_RESULT',
    COLD_SMTP_RESET_DOMAIN_RESULT : 'COLD_SMTP_RESET_DOMAIN_STATUS'
}

export default type;